import React, { useMemo } from 'react';
import { StepsSlideContext } from "../../context";
export var SecondaryContent = function SecondaryContent(_ref) {
  var index = _ref.index,
    isActive = _ref.isActive,
    children = _ref.children;
  var contextValue = useMemo(function () {
    return {
      index: index,
      isActive: isActive
    };
  }, [index, isActive]);
  return /*#__PURE__*/React.createElement(StepsSlideContext.Provider, {
    value: contextValue
  }, children);
};